var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "column-selector" }, [
    _c(
      "div",
      { staticClass: "columns-container" },
      _vm._l(_vm.columnGroups, function (group) {
        return _c(
          "div",
          { key: group.key, staticClass: "column-group" },
          [
            _c("h3", [_vm._v(_vm._s(group.label))]),
            _vm._v(" "),
            _vm._l(group.fields, function (field) {
              return _c(
                "div",
                { key: field.key, staticClass: "field-item" },
                [
                  _c("a-switch", {
                    staticClass: "custom-switch",
                    model: {
                      value: _vm.localSelectedColumns[field.key],
                      callback: function ($$v) {
                        _vm.$set(_vm.localSelectedColumns, field.key, $$v)
                      },
                      expression: "localSelectedColumns[field.key]",
                    },
                  }),
                  _vm._v(" "),
                  _c("span", { staticClass: "field-label" }, [
                    _vm._v(_vm._s(field.title)),
                  ]),
                ],
                1
              )
            }),
          ],
          2
        )
      }),
      0
    ),
    _vm._v(" "),
    _c(
      "div",
      { staticClass: "actions" },
      [
        _c("a-button", { on: { click: _vm.cancel } }, [
          _vm._v(_vm._s(_vm.$t("wp.cancel"))),
        ]),
        _vm._v(" "),
        _c(
          "a-button",
          { attrs: { type: "primary" }, on: { click: _vm.save } },
          [_vm._v(_vm._s(_vm.$t("ticket.save")))]
        ),
      ],
      1
    ),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }